// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../cache-deps/virtual-store/css-loader@3.6.0_webpack@4.46.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navbar[data-v-c310e3e0]{position:fixed!important}.settings a[data-v-c310e3e0]{margin-right:.75rem;margin-left:.75rem;display:inline-flex;width:auto;cursor:pointer;align-items:center;padding-left:.75rem;padding-right:.75rem;padding-top:.5rem;padding-bottom:.5rem;font-size:1.25rem;line-height:1.75rem;--tw-text-opacity:1;color:rgba(255,255,255,var(--tw-text-opacity))}", ""]);
// Exports
module.exports = exports;
